// extracted by mini-css-extract-plugin
export default {"social":"Social_social__YvB3W","media":"Social_media__CQCQA"};